<template>
  <div>
      <breadcrumbs/>
      <router-view
        v-if="ready && detailPageOpen"
        :key="$route.fullPath"
       />
        <div
          class="columns is-12 search-bar-contractor"
          v-if="!$route.query.Id"
        >

        <div
          class="column is-3"
        >
          <dropdown
            id="Allcontractortypes"
            class="search-filter"
            placeholder="Contractor type"
            :inner-label="false"
            v-model="licenseType"
            :options="this.$store.state.contractorLookup.licenseTypes"
            @change="setLicenseTypeFilter($event)"
          />
        </div>

        <div
          class="column is-3"
        >
          <dropdown
            id="Allcontractorstatuses"
            class="search-filter"
            placeholder="Contractor status"
            :inner-label="false"
            v-model="licenseStatus"
            :options="this.$store.state.contractorLookup.licenseStatuses"
            @change="setLicenseStatusFilter($event)"
          />
        </div>

        <div
          class="column is-6"
        >
          <SearchBox
            v-model="searchInput"
            @searchclear="searchInput = '', handleSearchFormSubmit()"
            :placeholder="placeholder"
            :handleSearchFormSubmit="handleSearchFormSubmit"
          >
          </SearchBox>
        </div>
      </div>

      <v-server-table
        v-show="!$route.query.Id"
        class="contractor-table"
        ref="contractor-table"
        :columns="tableColumns"
        :options="tableOptions"
        @loaded="loaded"
      >

        <template
          slot="contactname"
          slot-scope="{row}"
          class="multi-cell"
        > 
          {{ row.contactname }}
          <div
            class="contractor-violation"
            v-if="row.twoYearViolation"
          >
            <i class="fas fa-exclamation-triangle fa-2x"></i>
            <div class="violation-msg">Recent Contractor Licensing Violation (Previous 2 years)</div>
          </div>
        </template>

        <template
          slot="violationhistory"
          slot-scope="{row}"
          class="multi-cell"
        >
          <div v-if="!row.violationHistory">
            No Violation
          </div>
          <a 
            v-if="row.violationHistory"
            @click="openViolation(row)"
          >
            See Details
          </a>
        </template>

      </v-server-table>

      <div class="link-box">
        To view specific permits listed with a contractor, visit <a class="route-link" @click="routeTo('contractor-permit-lookup')">Contractor Permit Lookup</a>
      </div>

  </div>
</template>
<script>

import SearchBox from '@/components/SearchBox';
import _ from 'lodash';
import moment from 'moment';

import axios from 'axios';
import { Event } from 'vue-tables-2';

const cartoAxios = axios.create({
    baseURL: process.env.VUE_APP_CARTO_ROOT
});

export default {
  name: 'ContractorLookup',
  props: {
  },
  data() {
    return {
      searchAction: 'contractorLookup/getAllLicenses',
      placeholder: "Search by license holder, company, or #",
      searchInput: null,
      licenseType: null,
      routerQuery: {
        pageNumber: null,
        licenseType: null,
        licenseStatus: null,
        searchInput: null,
      },
      status: 'search',
      ready: false,
      tableOptions: {
        skin: 'table is-bordered is-fullWidth',
        requestAdapter: this.requestAdapter,
        requestFunction: this.requestFunction,
        responseAdapter: this.responseAdapter,
        sendInitialRequest: false,
        totalCount: null,
        perPage: 10,
        alwaysShowPerPageSelect: false,
        limit: 30,
        perPageValues: [5, 10, 25, 50, 100],
        headings: {
          contactname: 'Contact Name',
          companyname: 'Company Name',
          cal: 'CAL Number',
          licensetype: 'License Type',
          icccategory: 'License Categories',
          licensestatus: 'License Status',
          licensenumber: 'License Number',
          violationhistory: 'Violation History',
          issuedate: 'Issue Date',
          expirationdate: 'Expiration Date',
          balance: 'Balance',
        },
        pagination: {
          chunk: 5,
          edge: true,
        },
      },
      tableColumns: [
        'contactname',
        'companyname',
        'cal',
        'licensetype',
        'icccategory',
        'licensestatus',
        'licensenumber',
        'issuedate',
        'expirationdate',
        'violationhistory',
        'balance',
      ],
    }
  },
  components: {
    SearchBox,
  },
  beforeCreate(){
    this.$store.commit('updateHeader', 'contractorLookup');
  },

  created() {
    // console.log('ContractorLookup.vue created, this.$route:', this.$route);
    this.routerQuery.pageNumber = this.$route.query.pageNumber;
    this.routerQuery.licenseType = this.$route.query.licenseType;
    this.routerQuery.licenseStatus = this.$route.query.licenseStatus;
    this.routerQuery.searchInput = this.$route.query.searchInput;
    this.licenseType = this.$route.query.licenseType;
    this.licenseStatus = this.$route.query.licenseStatus;
    this.searchInput = this.$route.query.searchInput;

    this.getLicenseTypes();
    this.getLicenseStatuses();
    // console.log('created, this.$route.query:', this.$route.query, 'this.$route.query.pageNumber:', this.$route.query.pageNumber);
    this.getContractorViolations().then(() => {
      this.getCountAndData();

      if (this.$route.name == 'contractorLicenseViolation') {
        let row = {
          licensenumber: this.$route.query.Id,
        };
        this.openViolation(row);
      }
    });
    
    Event.$on('vue-tables.pagination', (data) => {
      // console.log('vue-tables.pagination, data:', data);
      this.page = data;
      this.changePage(data);
    });

    Event.$on('vue-tables.loaded', function (data) {
      let el1 = document.getElementsByClassName('VueTables__search');
      let el2 = document.getElementsByClassName('VueTables__limit');
      if (el1[0]) {
        el1[0].remove();
      }
      if (el2[0]) {
        el2[0].remove();
      }
    });
  },

  destroyed(){
    this.$store.commit('updateHeader', null);
  },

  watch: {
    routerQuery: {
      handler: function () {
        // console.log('watch routerQuery handler function is running');
        this.updateRouter();
      },
      deep: true,
    },
    '$route.query': function(newVal, oldVal) {
      // console.log('Router watcher, newVal: ', newVal, 'oldVal:', oldVal);
      if (Object.keys(newVal).length === 0) {
        this.$router.push({
          name: 'contractor-lookup',
          query: this.routerQuery,
        })
      }
    },
  },
  computed: {
    detailPageOpen(){
      return this.$store.state.detailPage
    },
  },
  methods: {
    routeTo(pRouteTo) {
      // console.log('pRouteTo:', pRouteTo, 'this.$route:', this.$route);
      if (this.$route.name == 'contractor-lookup') {
        // console.log('routeTo is running, starting from contractor-lookup');
        this.$router.push(pRouteTo);
      } else if (this.$route.name == 'contractorLicenseViolation') {
        // console.log('routeTo is running, starting from contractor-license-violation');
        if (pRouteTo == 'contractor-permit-lookup') {
          this.$router.push({
            name: 'contractorPermitLookup',
          });
        }
      }
    },
    getCountAndData() {
      // console.log('getCountAndData called');
      this.getCount().then(() => {
        if (!this.$route.query.pageNumber) {
          this.$refs['contractor-table'].getData();
        } else {
          this.$refs['contractor-table'].setPage(this.$route.query.pageNumber);
        }
      });
    },
    setLicenseTypeFilter(event) {
      // console.log('setLicenseTypeFilter called, this.licenseType:', this.licenseType, 'event:', event);
      this.updateRouterQuery('licenseType', this.licenseType).then(() => {
        this.getCountAndData();
      });
    },
    setLicenseStatusFilter(event) {
      // console.log('setLicenseStatusFilter called, this.licenseStatus:', this.licenseStatus, 'event:', event);
      this.updateRouterQuery('licenseStatus', this.licenseStatus).then(() => {
        this.getCountAndData();
      });
    },
    handleSearchFormSubmit() {
      // console.log('handleSearchFormSubmit called, this.searchInput:', this.searchInput);
      this.updateRouterQuery('searchInput', this.searchInput).then(() => {
        this.getCountAndData();
      });
    },

    async getCount() {
      let response = await cartoAxios.get('/', {
        params: {
          q: this.countQuery(),
        }
      });
      // console.log('getCount response:', response);
      this.tableOptions.totalCount = response.data.rows[0].count;
    },

    async getContractorViolations() {
      let response = await cartoAxios.get('/', {
        params: {
          q: `SELECT * FROM contractor_violations where licensetype not in ('Electrical Inspection Agency','Electrical Inspector')`,
        }
      });
      // console.log('getContractorViolations axios call response:', response);
      let rows = response.data.rows;
      for (let row of rows) {
        row.violationdate2year = moment(row.violationdate).add(2, 'years')._d;
      }
      this.$store.commit('contractorLookup/setContractorViolations', response.data.rows);
    },

    countQuery(options) {
      let query = `SELECT COUNT(*) FROM trade_licenses WHERE licensetype NOT IN ('ATTORNEY', 'DESIGN PROFESSIONAL', 'ELECTRICAL INSPECTION AGENCY', 'ELECTRICAL INSPECTOR')`;

      if (this.$route.query.licenseType) {
        // console.log('countQuery, inside if 1');
        query += ` AND licensetype = '` + this.$route.query.licenseType.toUpperCase() + `'`;
      }
      if (this.$route.query.licenseStatus) {
        // console.log('countQuery, inside if 2');
        query += ` AND licensestatus = '` + this.$route.query.licenseStatus.toUpperCase() + `'`;
      }
      if (this.$route.query.searchInput) {
        // console.log('countQuery, inside if 3');
        query += ` AND (lower(contactname) LIKE '%` + this.$route.query.searchInput.toLowerCase() + `%' OR lower(companyname) LIKE '%` + this.$route.query.searchInput.toLowerCase() + `%' OR licensenumber = '` + this.$route.query.searchInput + `')`;
      }
      return query;
    },

    changePage(page) {
      // console.log('changePage called, this.page:', page);
      this.updateRouterQuery('pageNumber', page);
    },

    async getLicenseTypes() {
      let response = await cartoAxios.get('/', {
        params: {
          q: `SELECT DISTINCT licensetype FROM trade_licenses WHERE licensetype NOT IN ('ATTORNEY', 'DESIGN PROFESSIONAL', 'ELECTRICAL INSPECTION AGENCY', 'ELECTRICAL INSPECTOR') ORDER BY licensetype`,
        }
      });
      // console.log('getLicenseTypes response:', response);
      this.$store.commit('contractorLookup/setLicenseTypes', response.data.rows);
    },

    async getLicenseStatuses() {
      let response = await cartoAxios.get('/', {
        params: {
          q: `SELECT DISTINCT licensestatus FROM trade_licenses WHERE licensetype NOT IN ('ATTORNEY', 'DESIGN PROFESSIONAL', 'ELECTRICAL INSPECTION AGENCY', 'ELECTRICAL INSPECTOR') ORDER BY licensestatus`,
        }
      });
      // console.log('getLicenseStatuses response:', response);
      this.$store.commit('contractorLookup/setLicenseStatuses', response.data.rows);
    },

    openViolation(row) {
      // console.log('openViolation is running, row:', row);
      let id = row.licensenumber ? row.licensenumber : row[0]['licensenumber']
      let violations = this.$store.state.contractorLookup.contractorViolations.filter(function(violation) {
        return violation.licensenumber == id;
      });
      let groupedViolations = Object.groupBy(violations, ({ casenumber }) => casenumber);
      // console.log('violations:', violations, 'groupedViolations:', groupedViolations, 'this.$route.name:', this.$route.name);

      this.$store.commit('contractorLookup/openViolationPage', groupedViolations);
      this.$store.commit('openDetail', row[0] ? row[0] : row );
      if(this.$route.name !== 'contractorLicenseViolation') {
        // console.log('in if');
        this.$router.push({
          name: 'contractorLicenseViolation',
          query: { Id: id },
        }).catch(e => {
          window.console.warn(e); 
          return;
        });
      } else {
        // console.log('in else');
        return;
      }
    },

    violationCheck(row){
      // console.log('violationCheck, row:', row);
      return row.violation
    },

    async updateRouterQuery(key, value) {
      // console.log('updateRouterQuery is running, key:', key, 'value:', value);
      if (!value) {
        this.$delete(this.routerQuery, key);
      } else {
        this.$set(this.routerQuery, key, value);
      }
    },

    updateRouter() {
      // console.log('updateRouter is running, this.routerQuery:', this.routerQuery, 'this.$route.query', this.$route.query);
      if (this.routerQuery === this.$route.query) {
        return;
      }

      if (this.$route.name == 'contractorLicenseViolation') {
        return;
      }

      if(Object.values(this.routerQuery).length > 0) {
        // console.log("update router running")
        this.$router.push({
          name: 'contractor-lookup',
          query: this.routerQuery,
        }).catch(e => {
          window.console.log(e);
          return
        });
      } else {
        this.$router.push({
          name: 'contractor-lookup',
        }).catch(e => {
          window.console.log(e); 
        });
      }
    },

    loaded(data) {
      // console.log('ContractorLookup.vue method loaded, data:', data);
      this.doingSearch = false;
      this.totalCount = data.total_rows;
    },

    reset() {
      // console.log('searches.js reset');
      Object.assign(this.$data, this.$options.data.apply(this));
      this.$router.push({ query: {} }).catch(err => { });  // eslint-disable-line
    },

    requestAdapter(options) {
      // console.log('requestAdapter called, options:', options, 'this.tableOptions:', this.tableOptions, 'this.$route.query:', this.$route.query);
      if (this.$route.query.pageNumber) {
        options.initialPage = this.$route.query.pageNumber;
      }
      options.limit = this.tableOptions.perPage;
      options.offset = (options.page - 1) * options.limit;
      options.totalCount = this.tableOptions.totalCount;
      if (options.totalCount < options.offset) {
        this.updateRouterQuery('pageNumber', 1);
        this.$refs['contractor-table'].setPage(1);
        options.page = 1;
        options.offset = 0;
      }
      // console.log('requestAdapter called, options:', options, 'this.options:', this.options, 'this.$route.query:', this.$route.query);
      return options;
    },

    requestFunction(options) {
      // console.log('requestFunction called, options:', options, 'this.$route.query:', this.$route.query);
      try {
        let response = cartoAxios.get('/', {
            params: {
              q: this.allLicensesQuery(options),
            }
        });
        // console.log('requestFunction, response:', response, 'response.data:', response.data);
        this.ready = true;
        return response;
      } catch (e) {
        console.log('requestFunction, error:', e);
        // this.dispatch('error', e);
      };
    },

    allLicensesQuery(options) {
      // console.log('allLicensesQuery, options:', options, 'this.$route.query.licenseType:', this.$route.query.licenseType, 'this.licenseType:', this.licenseType, 'this.searchInput:', this.searchInput);
      
      let query = `WITH cv AS (SELECT licensenumber, count(*) FROM contractor_violations \
      WHERE licensetype not in ('Electrical Inspection Agency','Electrical Inspector') \
      GROUP BY licensenumber),`

      query += ` rpb AS (SELECT * from resp_party_balance) `;

      query += ` SELECT tl.commercialactivitylicense as cal, tl.contactname, tl.companyname, tl.icccategory, tl.licensenumber, tl.licensetype, tl.licensestatus, tl.issuedate, tl.expirationdate, COALESCE(cv.count, 0) AS violationhistory, rpb.balance
      FROM trade_licenses tl`;

      query += ` LEFT JOIN cv ON tl.licensenumber = cv.licensenumber`;

      query += ` LEFT JOIN rpb ON tl.licensenumber = rpb.ct_licensenum`;
      
      query += ` WHERE tl.licensetype NOT IN ('ATTORNEY', 'DESIGN PROFESSIONAL', 'ELECTRICAL INSPECTION AGENCY', 'ELECTRICAL INSPECTOR')`;
      
      if (this.$route.query.licenseType) {
        // console.log('countQuery, inside if 1');
        query += ` AND tl.licensetype = '` + this.$route.query.licenseType.toUpperCase() + `'`;
      }
      if (this.$route.query.licenseStatus) {
        // console.log('countQuery, inside if 2');
        query += ` AND tl.licensestatus = '` + this.$route.query.licenseStatus.toUpperCase() + `'`;
      }
      if (this.$route.query.searchInput) {
        // console.log('countQuery, inside if 3');
        query += ` AND (lower(tl.contactname) LIKE '%` + this.$route.query.searchInput.toLowerCase() + `%' OR lower(tl.companyname) LIKE '%` + this.$route.query.searchInput.toLowerCase() + `%' OR tl.licensenumber = '` + this.$route.query.searchInput + `')`;
      }

      let direction;

      if (options.orderBy) {
        direction = options.ascending ? 'ASC' : 'DESC';
        query += ` ORDER BY ` + options.orderBy + ` ` + direction;
      } else {
        direction = 'DESC';
        query += ` ORDER BY issuedate ` + direction;
      }

      query += ` LIMIT ` + options.limit
      + ` OFFSET ` + options.offset;
      // console.log('allLicensesQuery, query:', query);
      
      return query;
    },

    responseAdapter(response) {
      // console.log('responseAdapter, response:', response);
      for (let row of response.data.rows) {
        row.twoYearViolation = false;
        row.violationHistory = false;
        row.issuedate = moment(row.issuedate).format('MM/DD/YYYY');
        row.expirationdate = moment(row.expirationdate).format('MM/DD/YYYY');
        row.balance = row.balance ? '$' + row.balance : '$0';
        if (row.licensenumber) {
          let currentDate = new Date();
          let contractorViolations = this.$store.state.contractorLookup.contractorViolations.filter(function(violation) {
            return violation.licensenumber == row.licensenumber;
          });
          let twoYearViolations = contractorViolations.filter(function(violation) {
            return moment(violation.violationdate2year).isAfter(currentDate);
          });
          // console.log('contractorViolations:', contractorViolations, 'twoYearViolations:', twoYearViolations);
          if (twoYearViolations.length > 0) {
            row.twoYearViolation = true;
          }
          if (contractorViolations.length > 0) {
            row.violationHistory = true;
          }
        }
      }
      return {
        data: response.data.rows,
        count: this.tableOptions.totalCount,
      };
    },

    clearSearchTable() {
      this.search.search = '';
      this.search.type = 'opaAccountNumber';
      this.reset();
    },

  },
};
</script>


<style lang="scss">

.link-box {
  display: inline-block;
  width: 100%;
  background-color: $ben-franklin-blue-light;
  padding: 15px 25px 15px 25px;
  margin: 15px 0 15px 0;
}

.route-link {
  font-weight: bold;
}

@media screen and (max-width: 768px) {
  #app > main {
      display: inline;
  }

  .search-bar {
    padding: 15px;
    div>div.is-10, div>div>form {
      margin: 0 15px 0 15px;
    }
  }

  .spinner-container {
    position: relative;
    padding: 50px;
  }

}

.search-filter select {
  background-color: white;
}

.to-uppercase {
  text-transform: uppercase;
}


.contractor-lookup tr {
  th:nth-child(1) {
      width: 33%;
    }
  th:nth-child(2), th:nth-child(3) {
      width: 25%;
    }
}
  #contractor>div.columns>div.column.is-12 {
    display: none;
  }

  .contractor-table {
    th {
      background-color: #444;
      color: white !important;
      border: 2px solid white !important;
    }

    td {
      border: 2px solid white !important;
    }

    tr.VueTables__row:nth-child(odd){
      background-color: #f0f0f0;
    }

    tr.VueTables__row:nth-child(even){
      background-color: #cfcfcf;
    }
  }


</style>

<style lang="scss" scoped>

@media screen and (min-width: 768px) {
  #contractor.results-table {
    padding-left: 45px;
    padding-right: 50px;
  }

  .search-bar-contractor {
    padding: 15px 35px 15px 35px;
  }

}
  #contractor.results-table {
    // margin-left: -0.75rem !important;
    // margin-right: -0.75rem !important;
    padding: unset;
  }

  div.column>.input-wrap {
    padding: 0;
  }
  .detail {
    margin: auto;
  }
  .search-bar-contractor {
    // display: flow-root;
    background-color: $ben-franklin-blue-light;
    // padding: 15px 35px 15px 35px;
    &.columns {
      margin-top: 0;
      margin-bottom: 0;
    }

    .column {
      padding-top: 5px;
      padding-bottom:5px;
    }
  }
  .search-bar-content {
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    h3 {
      color: $grey-medium;
      margin-bottom: 50px;
    }
    p>a::after {
    font-family: "Font Awesome 5 Pro";
    content: "\f08e";
    font-size: smaller;
    padding-left: 2px;
    }
  }
  .bottom-grey-header{
    background-color: $ghost-grey;
    bottom: 0;
    position: absolute;
    width: 100%;
    left: 0;
    text-align: center;
    padding: 25px;
    font-size: larger;
  }

  .contractor-violation {
    display: block;
    text-transform: none;
    font-size: smaller;
    color: $love-park-red-dark;
  }

  .left {
    float: left;
  }

  i.fa-exclamation-triangle {
    float: left;
    margin-right: 10px;
    padding-top: 10px;
  }

  .violation-msg {
    display: inline-flex;
  }

  .search-filter {
    margin-top: 8px;
  }

</style>
